import React, {PropTypes} from 'react';
import {Link} from 'react-router';

const RecipeFilter = ({sortRecipes,filterRecipes,filterClass,toggleFilter}) => {	
	let closeFilter = require('../../images/ui-close-rose.png');	

	return(
		<div 
			className={filterClass}
		>
			<div className="close-filter" style={{backgroundImage: `url(${closeFilter})`}} onClick={toggleFilter}>X</div>
			<div className="filter-container">
				<h2>Filter...</h2>
				<p>Cuisine:</p>
				<div className="filter-options">
					<input onClick={filterRecipes} type="checkbox" data-field="cuisine" value="Spanish" /><span>Spanish</span>
					<input onClick={filterRecipes} type="checkbox" data-field="cuisine" value="French" /><span>French</span>
					<input onClick={filterRecipes} type="checkbox" data-field="cuisine" value="Indian" /><span>Indian</span>
				</div><br />
				<p>Ingredients:</p>
				<div className="filter-options">
					<input onClick={filterRecipes} type="checkbox" data-field="ingredients" value="Basil" /><span>Basil</span>
					<input onClick={filterRecipes} type="checkbox" data-field="ingredients" value="Cumin" /><span>Cumin</span>
					<input onClick={filterRecipes} type="checkbox" data-field="ingredients" value="Herbes de Provence" /><span>Herbes de Provence</span>
					<input onClick={filterRecipes} type="checkbox" data-field="ingredients" value="Oregano" /><span>Oregano</span>
				</div><br />
				<p>Sort By:</p>
				<ul>
					<li onClick={sortRecipes} data-sort="dateAdded">Newest</li>
					<li onClick={sortRecipes} data-sort="title">Title</li>
					<li onClick={sortRecipes} data-sort="authorLastName">Author</li>
				</ul>
			</div>
		</div>
	);
};

RecipeFilter.propTypes = {
	sortRecipes: PropTypes.func.isRequired,
	filterRecipes: PropTypes.func.isRequired,
	filterClass: PropTypes.string.isRequired,
	toggleFilter: PropTypes.func.isRequired
};

export default RecipeFilter;


/** WEBPACK FOOTER **
 ** ./src/components/collections/RecipeFilter.js
 **/